import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { API_MAP } from '../../../core/helpers/api.map';
import { map } from 'rxjs';
import { SearchResultService } from './search-result.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const SearchResultResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(SearchResultService)
    .get(API_MAP.globalSearchPage + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
